import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { AmplifyApiService } from 'src/app/core/services/amplify-api.service';
import {
  QAPostNotificationFail,
  QAPostNotificationSuccess,
  RtpSendFailed,
  RtpSendSuccess
} from 'src/app/features/qa-testing/redux/qa.actions';
import { QAInsightEvent } from 'src/app/models/qa-models/qa-models';
import { RealTimePersonalizationEvent } from 'src/app/models/rtp-models';
import { APIS } from 'src/app/shared/constants/api-constants';
import { ENVIRONMENT } from 'src/environments/environment';

@Injectable({
  providedIn: 'any'
})
export class QaServiceService {
  public submittedNotification;
  public notifications_api = APIS.NOTIFICATIONS;
  public rtp_api = APIS.RTP;

  constructor(
    private store: Store,
    private apiService: AmplifyApiService
  ) {}

  public submitNotification(notification: QAInsightEvent): void {
    this.apiService
      .post(this.notifications_api, `/${ENVIRONMENT.name}/campaigns/qa/notifications`, { body: notification })
      .then((response) => {
        this.submittedNotification = response;
        this.store.dispatch(new QAPostNotificationSuccess());
      })
      .catch((error) => {
        this.store.dispatch(new QAPostNotificationFail(error));
      });
  }

  public submitRTPNotification(event: RealTimePersonalizationEvent): void {
    this.apiService
      .put(this.rtp_api, `/${ENVIRONMENT.name}/campaigns/qa/rtp`, { body: event })
      .then(() => {
        this.store.dispatch(new RtpSendSuccess());
      })
      .catch(() => {
        this.store.dispatch(new RtpSendFailed());
      });
  }
}
